"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// 监控基础类
var BaseMonitor = /*#__PURE__*/function () {
  function BaseMonitor() {
    var _this2 = this;

    _classCallCheck(this, BaseMonitor);

    _defineProperty(this, "onFetch", function () {});

    _defineProperty(this, "onJsError", function () {});

    _defineProperty(this, "onPageUnload", function () {});

    _defineProperty(this, "syncRequest", function (url, params) {
      var http = new _this2.XMLHttpRequest();
      http.setRequestHeader('Content-type', 'application/json; charset=utf-8');
      http.open('POST', url, false);
      http.send(params);
    });

    // 暴露五个方法
    // reWriteEvent：重写 EventTarget.prototype.addEventListener
    // listenFetch：监听 xhr 请求，onFetch 上报
    // listenJsError：监听 window.addEventListener js 错误，onJsError 上报
    // listenPageUnload：监听页面退出（分web、weex、wx） onPageUnload 上报
    // listenPromise：异步错误 ，监听 window.addEventListener("unhandledrejection") reportJsError 上报
    try {
      this.reWriteEvent();
      this.listenFetch();
      this.listenJsError();
      this.listenPageUnload();
      this.listenPromise();
    } catch (e) {
      console.error('FeMonitor:', e);
    }
  }

  _createClass(BaseMonitor, [{
    key: "getEnv",
    value: function getEnv() {
      try {
        if (this.env) {
          return this.env;
        }

        if ((typeof wx === "undefined" ? "undefined" : _typeof(wx)) === 'object') {
          this.env = 'wx';
        } else if ((typeof weex === "undefined" ? "undefined" : _typeof(weex)) === 'object') {
          this.env = 'weex';
        } else if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object') {
          this.env = 'web';
        }

        return this.env;
      } catch (e) {
        return '';
      }
    }
  }, {
    key: "reWriteEvent",
    value: function reWriteEvent() {
      // if (this.getEnv() === 'web' && document.write) {
      //   document.write(`<script>
      //   const originAddEventListener = EventTarget.prototype.addEventListener;
      //   EventTarget.prototype.addEventListener = function (type, listener, options) {
      //     const wrappedListener = function (...args) {
      //       try {
      //         return listener.apply(this, args);
      //       }
      //       catch (err) {
      //         throw err;
      //       }
      //     }
      //     listener._MONITOR_PROXY = wrappedListener;
      //     return originAddEventListener.call(this, type, wrappedListener, options);
      //   }
      //   const originRemoveEventListener = EventTarget.prototype.removeEventListener;
      //   EventTarget.prototype.removeEventListener = function (type, listener, options) {
      //     return originRemoveEventListener.call(this, type, listener && listener._MONITOR_PROXY , options);
      //   }</script>`)
      // }
      if (this.getEnv() === 'web') {
        var reWriteOriginAddEventListener = "const originAddEventListener = EventTarget.prototype.addEventListener;\n      EventTarget.prototype.addEventListener = function (type, listener, options) {\n        const wrappedListener = function (...args) {\n          try {\n            return listener.apply(this, args);\n          }\n          catch (e) {\n            /** \u9519\u8BEF\u5806\u6808\u4FE1\u606F */\n            const _stack = e.stack || (e.error && e.error.stack);\n            console.log('_stack', _stack)\n            if (_stack) {\n              /** \u6E90\u7801\u4E2D\u9519\u8BEF\u4EE3\u7801\u76F8\u5173\u4FE1\u606F */\n              const caller_line = _stack.split(\"\\n\")[1];\n              console.log('caller_line', caller_line);\n              /** \u6839\u636E\u5C0F\u62EC\u53F7\u83B7\u53D6\u6709\u610F\u4E49\u7684\u9519\u8BEF\u4FE1\u606F\u5185\u5BB9 */\n              const caller_line_arr = caller_line.match(/\\((.+?)\\)/g);\n              /** \u53BB\u6389 caller_line \u5B57\u7B26\u4E32\u4E2D\u7684\u5C0F\u62EC\u53F7 */\n              const caller_line_content = caller_line_arr[0].substring(1, caller_line_arr[0].length).substring(0, caller_line_arr[0].length - 2);\n              console.log('caller_line_content', caller_line_content)\n              /** \u6839\u636E\u5206\u53F7\u8FDB\u884C\u5207\u5272\u6210\u6570\u7EC4 */\n              const caller_line_content_arr = caller_line_content.split(':');\n              const caller_line_content_arr_length = caller_line_content_arr.length;\n              /** \u83B7\u53D6\u9519\u8BEF\u4FE1\u606F\uFF1A\u884C */\n              const lineno = caller_line_content_arr[caller_line_content_arr_length - 2];\n              /** \u83B7\u53D6\u9519\u8BEF\u4FE1\u606F\uFF1A\u5217 */\n              const colno = caller_line_content_arr[caller_line_content_arr_length - 1];\n              /** \u83B7\u53D6\u9519\u8BEF\u4FE1\u606F\uFF1A\u6240\u5728\u6587\u4EF6\u540D */\n              const filename = caller_line_content_arr.splice(0, caller_line_content_arr_length - 2).join('');\n              console.log('lineno', lineno);\n              console.log('colno', colno);\n              console.log('filename', filename);\n\n              /** \u81EA\u5B9A\u4E49\u5F02\u5E38\u7C7B\u578B */\n              function CustomError () {\n                this.message = 'Uncaught ' + e.name + ': ' + e.message || '';\n                this.colno = colno;\n                this.lineno = lineno;\n                this.filename = filename;\n              }\n              CustomError.prototype = Object.create(Error.prototype);\n              CustomError.prototype.constructor = CustomError;\n\n              throw new CustomError();\n            }\n          }\n        }\n        listener._MONITOR_PROXY = wrappedListener;\n        return originAddEventListener.call(this, type, wrappedListener, options);\n      }\n      const originRemoveEventListener = EventTarget.prototype.removeEventListener;\n      EventTarget.prototype.removeEventListener = function (type, listener, options) {\n        return originRemoveEventListener.call(this, type, listener && listener._MONITOR_PROXY , options);\n      }";
        var scriptEle = document.createElement("script");
        scriptEle.async = false;
        scriptEle.defer = false;
        scriptEle.append(reWriteOriginAddEventListener);
        document.head.append(scriptEle);
      }
    }
    /**
     * [reWriteFetch description]
     * @return {[type]} [description]
     */

  }, {
    key: "listenFetch",
    value: function listenFetch() {
      var _this = this;

      if (this.getEnv() === 'web') {
        if (window.fetch) {
          this.originFetch = window.fetch;
          var originFetch = window.fetch;

          window.fetch = function (url, options) {
            var startTime = +new Date();
            return originFetch.call(this, url, options).then(function (response) {
              _this.onFetch({
                url: url,
                success: response.ok,
                duration: +new Date() - startTime,
                code: response.status,
                message: response.statusText
              });

              return response;
            }).catch(function (err) {
              _this.onFetch({
                url: url,
                success: false,
                duration: +new Date() - startTime,
                code: 0,
                message: err && err.message || ''
              });

              throw err;
            });
          };
        }

        if (window.XMLHttpRequest) {
          this.XMLHttpRequest = window.XMLHttpRequest;

          var newXhr = /*#__PURE__*/function (_XMLHttpRequest) {
            _inherits(newXhr, _XMLHttpRequest);

            var _super = _createSuper(newXhr);

            function newXhr() {
              _classCallCheck(this, newXhr);

              return _super.call(this);
            }

            _createClass(newXhr, [{
              key: "open",
              value: function open() {
                this.startTime = +new Date();

                _get(_getPrototypeOf(newXhr.prototype), "open", this).apply(this, arguments);

                var url = arguments[1];
                this.addEventListener('readystatechange', function () {
                  if (this.readyState == 4) {
                    var dur = +new Date() - this.startTime;

                    if (this.status == 200) {
                      _this.onFetch({
                        url: url,
                        success: true,
                        duration: dur,
                        code: 200
                      });
                    } else {
                      _this.onFetch({
                        url: url,
                        success: false,
                        duration: dur,
                        code: this.status,
                        message: this.responseText || ''
                      });
                    }
                  }
                });
              }
            }]);

            return newXhr;
          }( /*#__PURE__*/_wrapNativeSuper(XMLHttpRequest));

          window.XMLHttpRequest = newXhr;
        }
      } else if (this.getEnv() === 'wx') {
        var originRequest = wx.request;
        this.originRequest = originRequest;

        var newRequest = function newRequest(options) {
          var startTime = +new Date();
          var originSuccess = options.success;
          var originFail = options.fail;
          return originRequest.call(this, _objectSpread(_objectSpread({}, options), {}, {
            success: function success(res) {
              _this.onFetch({
                url: options.url,
                success: true,
                duration: +new Date() - startTime,
                code: res.statusCode,
                message: res.errMsg || ''
              });

              originSuccess && originSuccess(res);
            },
            fail: function fail(err) {
              _this.onFetch({
                url: options.url,
                success: false,
                duration: +new Date() - startTime,
                code: err.statusCode,
                message: err.errMsg || ''
              });

              originFail && originFail(err);
            }
          }));
        };

        Object.defineProperty(wx, 'request', {
          configurable: true,
          enumerable: true,
          writable: true,
          value: newRequest
        });
        wx.request = newRequest;
      }
    }
  }, {
    key: "listenJsError",

    /**
     * 监听js报错
     * @return {[type]} [description]
     */
    value: function listenJsError() {
      var _this3 = this;

      if (this.getEnv() === 'web' && window.addEventListener) {
        window.addEventListener('error', function (evt) {
          var message = evt.message,
              lineno = evt.lineno,
              colno = evt.colno,
              error = evt.error,
              filename = evt.filename;
          var info = Object.assign({}, {
            message: message,
            lineno: lineno,
            colno: colno,
            filename: filename
          }, _objectSpread({}, error)); // evt.error ? evt.error.stack : evt.message

          _this3.onJsError(JSON.stringify(info)); // document.querySelector('#info').textContent = info;

        });
      } else if (this.getEnv() === 'wx' && wx.onError) {
        wx.onError(function (msg) {
          _this3.onJsError(msg);
        });
      }
    }
  }, {
    key: "listenPromise",
    value: function listenPromise() {
      var _this4 = this;

      if (this.getEnv() === 'web' && window.addEventListener) {
        window.addEventListener("unhandledrejection", function (e) {
          var reason = e.reason;

          if (!reason) {
            return;
          }

          _this4.reportJsError({
            message: reason.message,
            attr: {
              message: reason.message,
              stack: reason.stack,
              type: 'promise'
            }
          });
        });
      }
    }
    /**
     * 监听页面退出
     * @return {[type]} [description]
     */

  }, {
    key: "listenPageUnload",
    value: function listenPageUnload() {
      var _this5 = this;

      if (this.getEnv() === 'web') {
        window.addEventListener('beforeunload', function (e) {
          _this5.onPageUnload();
        });
        window.addEventListener('unload', function (e) {
          _this5.onPageUnload();
        });
        window.Fusion && window.Fusion.registerEventListener && window.Fusion.registerEventListener({
          event: 'UIApplicationDidEnterBackgroundNotification'
        }, function (data) {
          _this5.onPageUnload();
        });
      } else if (this.getEnv() === 'weex') {
        var globalEvent = weex.requireModule('globalEvent');
        globalEvent.addEventListener('WXApplicationWillResignActiveEvent', function (e) {
          try {
            _this5.onPageUnload();
          } catch (e) {
            console.warn(e);
          }
        });
        globalEvent.addEventListener('UIApplicationDidEnterBackgroundNotification', function (e) {
          try {
            _this5.onPageUnload();
          } catch (e) {
            console.warn(e);
          }
        });
      } else if (this.getEnv() === 'wx' && wx.onAppHide) {
        wx.onAppHide(function () {
          _this5.onPageUnload();
        });
      }
    }
  }]);

  return BaseMonitor;
}();

var _default = BaseMonitor;
exports.default = _default;